/**
 * Determine the mobile operating system and returns the
 * proper javascript interface
 */
var Ayoba = getAyoba();

function getAyoba() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return null;
  }

  if (/android/i.test(userAgent)) {
    return window["Android"];
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return null; // todo
  }

  return "unknown";
}

// ============================================================= FUNCTIONS ============================================================================

export function startPaymentOverlay(amount, currency, description) {
  if (amount > 0 && currency) {
    try {
      Ayoba.startPayment(amount, currency, description);
    } catch (err) {
      console.log(err);
    }
  }
}

// function onPaymentStatusChanged(transactionId, status, error) {
//   let res = `Transaction ID: ${transactionId}, Status: ${status}, Error: ${error}`;

//   console.log(res);
// }

// onPaymentStatusChanged();
